import(/* webpackMode: "eager" */ "C:\\react\\lakeeshop\\src\\app\\global-error.tsx");
